@if (site) {
  <div class="container">
    <button mat-icon-button class="material-symbols-outlined"
      [matTooltip]="'move_camera_to_site' | transloco"
    (click)="onClickFlyToSite(site)">my_location</button>
  </div>
}
<div style="height: 10px; width: 10px"></div>
@if (site) {
  <div class="container"
    matTooltip="{{toolTip((advancedFeaturesAvailable$ | async))}}">
    <button mat-icon-button class="material-symbols-outlined"
      [matTooltip]="'straight_line_measurement' | transloco"
      (click)="drawLine($event)"
      [disabled]="isComputing || !(advancedFeaturesAvailable$ | async)"
    [color]="(isDrawingLine) ? 'accent' : 'black'">straighten</button>
    <button mat-icon-button class="material-symbols-outlined"
      [matTooltip]="'measuring_area_and_volume' | transloco"
      (click)="drawPolygon($event)"
      [disabled]="isComputing || !(advancedFeaturesAvailable$ | async)"
    [color]="(isDrawingPolygon) ? 'accent' : 'black'">activity_zone</button>
    <button mat-icon-button class="material-symbols-outlined"
      [matTooltip]="'draw_cut' | transloco"
      (click)="drawCut($event)"
      [disabled]="isComputing || !(advancedFeaturesAvailable$ | async)"
    [color]="(isDrawingCut) ? 'accent' : 'black'">landscape</button>
    <button mat-icon-button class="material-symbols-outlined"
      [matTooltip]="'put_elevation' | transloco"
      (click)="drawElevation($event)"
      [disabled]="isComputing || !(advancedFeaturesAvailable$ | async)"
    [color]="(isDrawingElevation) ? 'accent' : 'black'">altitude</button>
    <button mat-icon-button class="material-symbols-outlined"
      [matTooltip]="'put_marker' | transloco"
      [disabled]="isComputing || !(advancedFeaturesAvailable$ | async)"
      (click)="drawMarker($event)"
    [color]="(isDrawingMarker) ? 'accent' : 'black'">radio_button_checked</button>
    @if (site | module: [inspectionModule.ARCAD]) {
      <button
        mat-icon-button class="material-symbols-outlined"
        [matTooltip]="'create_new_detection' | transloco"
        (click)="drawNewDetection($event)"
        [disabled]="isComputing || !(advancedFeaturesAvailable$ | async)"
      [color]="(isDrawingNewDetection) ? 'accent' : 'black'">capture</button>
    }
  </div>
}

